module.exports = __webpack_public_path__ + "img/mushroom-desktop.c8e91c27.png";